import favicon from 'assets/images/favicon-v2.ico';

// ==============================|| LOGO ICON（favicon-v2.ico） ||============================== //

export default function LogoIcon() {
  return <img src={favicon} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />;
}
